<template>
  <div class="hora">
    <div
      class="show container"
      style="font-family: IRANSansX-Regular">
      <div
        class="col-12 mb-3 p-2"
        style="
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
        border: 1px solid rgba(0, 0, 0, 0.175);
        border-radius: 8px;
        background: #fff;
      ">
        <ReportForm
          @appViewUpdateData="updateLoadedData"
          @updateShowAnalysis="updateShowAnalysisOption"
        />

      </div>
    </div>
  </div>
</template>

<script>
import Chart from '../components/Chart.vue'
import ChartListPro from '../components/ChartListPro.vue'
import ChartInfoFree from '../components/ChartInfoFree.vue'
import ChartAnalysisFree from '../components/ChartAnalysisFree.vue'
import ShareLinkFree from '../components/ShareLinkFree.vue'
import ReportForm from '../components/ReportForm.vue'
import PlanetryTableFree from '../components/PlanetryTableFree.vue'
import DashaTable from '../components/DashaTable.vue'
import HelperLib from '../components/helper'
import HoraLogo from '../components/HoraLogo.vue'
import DatePicker from '../components/DatePicker.vue'
import TimePicker from '../components/TimePicker.vue'
// import ApiService from "../service/api";

export default {
  name: 'GetReportForm',
  components: {
    Chart,
    ChartListPro,
    ChartInfoFree,
    ChartAnalysisFree,
    ReportForm,
    PlanetryTableFree,
    DashaTable,
    HelperLib,
    HoraLogo,
    ShareLinkFree,
    DatePicker,
    TimePicker
    // ChartNotesPro,
    // ApiService,
  },
  data () {
    return {
      chart2Varga: 'D9',
      chart3Varga: 'D30',
      chart2Text: 'D9 - Navamsa Chart',
      chart3Text: 'D30 - Trimshamsha',
      link_clicked: false,
      loadData: [],
      box_width: null,
      main_box_width: null,
      pages: {
        is_calculate: true,
        is_charts: false,
        is_notes: false
      }
    }
  },
  watch: {
    loadData: function (data) {
      this.loadData = data
    }
  },
  mounted: function () {
  },
  methods: {

    isMobile () {
      return HelperLib.isMobile()
    },
    showMobileViewChartHeader (width) {
      return `
      font-size: 12px; 
      border-radius: 8px; 
      width: ${width}px;  
      line-height: 10px; 
      color: #000;`
    },
    formatLocation (user) {
      let lonDir = user['longitude'] < 0 ? 'W' : 'E'
      let latDir = user['latitude'] < 0 ? 'S' : 'N'
      let out =
        user['latitude_dms']['deg'] +
        ' ' +
        latDir +
        ' ' +
        user['latitude_dms']['min'] +
        ' - '
      out +=
        user['longitude_dms']['deg'] + ' ' + lonDir + ' ' + user['longitude_dms']['min']
      return out
    },
    getNowAnalysis (user) {
      let time = user['hour'] + ':' + user['min'] + ':' + user['sec']
      let date = user['j_year'] + '-' + user['j_month'] + '-' + user['j_day']
      let out = `
      شما در حال مشاهده چارت در ساعت ${time} و تاریخ  هستید.
      `
      return out
    },
    formatLagnaText (rashi) {
      return HelperLib.rashiToPersianText(rashi)
    },
    getSignLink (data) {
      var lagna = HelperLib.rashiToPersianText(data['lagna']['Lg']['rashi'])
      return `${lagna[1]}`
    },
    updateLoadedData (data) {
      this.loadData = data
      // this.$chartNoteListRef.getList();
    },
    updateShowAnalysisOption (data) {
      this.show_analysis = data
    }
  }
}
</script>

<style scoped>

.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
.custom-accordion-header {
  background-color: #f2f2f2;
  color: #333;
  border: 1px solid #ccc;
}

.custom-accordion-header:hover {
  background-color: #e6e6e6;
}

.custom-accordion-header.active {
  background-color: #ddd;
}
.accordion-button-custom:not(.collapsed) {
  color: #000000;
  font-weight: bold;
  background-color: #fff;
  box-shadow: inset 0 -1px 0 rgb(0 0 0 / 13%);
}

* {
  padding: 0px;
  margin: 0px;
}
.now-analysis {
  direction: rtl;
  text-align: right;
  background-color: rgba(255, 253, 231, 0.5);
  border-radius: 0.25rem;
  font-size: 16px;
  color: black;
  border: 1px solid rgb(242, 242, 242);
}
.loading {
  left: 0px;
  top: 0px;
  right: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(255, 255, 255, 0.8);
}
</style>
<!-- <style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style> -->
